// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const processInclusionExcelData = (data: any[]) => {
  try {
    throwErrorIfEmpty(data);
    const firstRow = data[0];

    throwErrorIfInvalidExcelStructure(firstRow);
    const categories = getCategories(firstRow);

    throwErrorIfNoCategories(categories);
    return categorizeData(data, categories);
  } catch (error) {
    throwGenericError();
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const categorizeData = (data: any[], categories: string[]) => {
  const categorizedData = initializeCategories(categories);

  data.forEach((row) => {
    throwErrorIfInvalidRowStructure(row);
    let hasValidItem = false;

    categories.forEach((category) => {
      hasValidItem =
        processItem(row, category, categorizedData) || hasValidItem;
    });
    throwErrorInvalidItem(hasValidItem);
  });
  return categorizedData;
};

const initializeCategories = (categories: string[]) => {
  const categorizedData: { [key: string]: string[] } = {};

  categories.forEach((category) => {
    categorizedData[category] = [];
  });
  return categorizedData;
};

const getCategories = (firstRow: unknown[]) => {
  return Object.keys(firstRow).filter((key) => key !== "__rowNum__");
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const processItem = (
  row: any,
  category: string,
  categorizedData: { [key: string]: string[] }
) => {
  if (row[category]?.trim()) {
    categorizedData[category].push(row[category].trim());
    return true;
  }

  return false;
};

const throwErrorIfEmpty = (data: unknown[]) => {
  if (!data || data.length === 0) {
    throw new Error("Excel file is empty");
  }
};

const throwErrorIfInvalidExcelStructure = (data: unknown[]) => {
  if (!data || typeof data !== "object") {
    throw new Error("Invalid Excel structure");
  }
};

const throwErrorIfNoCategories = (categories: unknown[]) => {
  if (categories.length === 0) {
    throw new Error("No categories found in Excel file");
  }
};

const throwErrorIfInvalidRowStructure = (row: unknown[]) => {
  if (!row || typeof row !== "object") {
    throw new Error("Invalid row structure in Excel file");
  }
};

const throwErrorInvalidItem = (hasInvalidItem: boolean) => {
  if (!hasInvalidItem) {
    throw new Error("Found empty row in Excel file");
  }
};

const throwGenericError = () => {
  throw new Error(
    "Please check your file structure to match inclusions format"
  );
};
